import { Component, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sections',
  templateUrl: './sections.component.html',
  styleUrls: ['./sections.component.scss'],
})
export class SectionsComponent {
  @Output() sectionChange: EventEmitter<any> = new EventEmitter<any>();

  @Input() selectedSection: string;

  apps: string = 'apps';
  security: string = 'security';
  constructor(public translate: TranslateService) {}

  public sectionClick(psSection: string): void {
    this.selectedSection = psSection;
    this.sectionChange.emit(psSection);
  }
}
